import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import type { ConversionResponse } from '../../../types/smart-router';

interface Props { data: ConversionResponse; }

const Gauge: React.FC<{ value: number; label: string; color: string }> = ({ value, label, color }) => {
  const chartData = { datasets: [{ data: [value, 100 - value], backgroundColor: [color, '#f3f4f6'], borderWidth: 0, cutout: '75%' }] };
  const opts = { responsive: true, maintainAspectRatio: false, plugins: { legend: { display: false }, tooltip: { enabled: false } } };
  return (
    <div className="flex flex-col items-center">
      <div className="relative w-28 h-28">
        <Doughnut data={chartData} options={opts} />
        <div className="absolute inset-0 flex items-center justify-center">
          <span className="text-xl font-semibold text-text-primary">{value}%</span>
        </div>
      </div>
      <span className="mt-2 text-sm font-medium text-text-secondary">{label}</span>
    </div>
  );
};

export const ConsentConversionGauges: React.FC<Props> = ({ data }) => (
  <div className="border border-border-default rounded-xl shadow-md overflow-hidden">
    <div className="bg-gradient-to-b from-primary-50 to-primary-100 px-4 py-3">
      <h2 className="text-sm font-semibold text-text-primary tracking-wider">Consent Conversion Performance</h2>
    </div>
    <div className="bg-white p-5">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="border border-border-default rounded-lg p-4">
          <h3 className="text-sm font-medium text-text-secondary mb-4 text-center tracking-wide">Consent Level</h3>
          <div className="flex justify-center gap-8">
            <Gauge value={data.with_sr.consent_level.success_rate} label="With SR" color="#6366f1" />
            <Gauge value={data.without_sr.consent_level.success_rate} label="Without SR" color="#9ca3af" />
          </div>
        </div>
        <div className="border border-border-default rounded-lg p-4">
          <h3 className="text-sm font-medium text-text-secondary mb-4 text-center tracking-wide">User Level</h3>
          <div className="flex justify-center gap-8">
            <Gauge value={data.with_sr.user_level.success_rate} label="With SR" color="#10b981" />
            <Gauge value={data.without_sr.user_level.success_rate} label="Without SR" color="#9ca3af" />
          </div>
        </div>
      </div>
    </div>
  </div>
);
